import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import ActionCenterSent from './ActionCenterSent';

loadDOMComponent({
	selector: 'react-action-center-sent',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ActionCenterSent />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
